module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Header/images/defeat-background.9d9e90a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/images/defeat-background.jpg
// module id = 3232
// module chunks = 11